export default defineNuxtRouteMiddleware((to, from) => {



    return


  // Only execute on client-side (where link clicks happen)
  if (import.meta.server) return

  const router = useRouter()

  // 1. Check if the target route matched the catch-all wildcard [...slug] route
  const isCatchAll = to.matched.some(record => 
    record.path.includes('[...slug]') || record.path.includes(':slug')
  )

  // 2. Alternatively check if no matched routes exist at all
  const isNotFound = to.matched.length === 0 || isCatchAll

  if (isNotFound) {
    const sourcePage = from.fullPath !== to.fullPath ? from.fullPath : (document.referrer || 'Direct Entry')
    const targetLink = to.fullPath

    console.warn(`[Broken Link Detected] User clicked a broken link!`, {
      fromPage: sourcePage,   // The page where the user was when clicking
      targetUrl: targetLink,  // The broken link URL
      timestamp: new Date().toISOString()
    })

    // OPTIONAL: Send payload to your logging endpoint (e.g. FastAPI / MongoDB)
    /*
    $fetch('/api/v1/log-broken-link', {
      method: 'POST',
      body: {
        source_page: sourcePage,
        broken_target: targetLink
      }
    }).catch(() => {})
    */
  }
})
